import { default as React, ReactNode } from "react";

export const TabButton = ({
    children,
    active,
    onClick,
    twInactive = "text-black",
    twWidth = "w-fit",
    twActive = "bg-reonic-yellow",
}: {
    children: ReactNode;
    active?: boolean;
    onClick: () => void;
    twInactive?: string;
    twWidth?: string;
    twActive?: string;
}) => {
    return (
        <>
            <button
                onClick={() => onClick()}
                className={` transition-colors duration-300
                    rounded-full  font-semibold sm:py-2 sm:px-4 py-1 px-2 sm:text-sm text-xs
                    ${twWidth}
                    ${active ? twActive : twInactive}
                `}
            >
                {children}
            </button>
        </>
    );
};

export const TabToggleContainer = ({
    children,
    twBackground = "bg-zinc-100",
    className,
}: {
    children: ReactNode;
    twBackground?: string;
    className?: string;
}) => {
    return (
        <div
            className={`shrink-0 h-fit flex p-1 w-fit rounded-[20px] gap-2 ${twBackground} ${className}`}
        >
            {children}
        </div>
    );
};
